export default __webpack_public_path__ + "static/media/gold.a841bc7a.png";